import { ppData } from '../configs/ppData.config';
import { useSearchParams } from 'react-router-dom';
import { SEARCH_PARAM_KEY_LAYOUT } from '../constants/searchParamKeys';
export const useImage = (searchParams = useSearchParams()[0]) => {
    const layout = searchParams.get(SEARCH_PARAM_KEY_LAYOUT) ?? Object.keys(ppData.images)[0];
    const imagesObj = ppData.images[layout];
    return imagesObj['3d'].auto !== undefined && imagesObj['3d'].auto.length > 0
        ? imagesObj['3d'].auto
        : imagesObj.rooms[0].url;
};
